export default "__VITE_ASSET__B9LGi_pm__"